import React from 'react';
// Gameplayer imports
import { connect } from 'react-redux';
import store from '../../store';
import MobileControls from './MobileControls';
import GameInfo from './GameInfo';
import LevelPopup from './LevelPopup';
import PauseOverlay from './pause';
import settings from '../../../settings';
// Game(kit) imports
import PlayerLoadScreen from './LoadingScreen';
import { gameplayerSetLoadingComplete } from '../../actions/loadingActions';
import { ViewDirection } from '../../../GameKit/shared';

class GamePlayerUI extends React.Component {
    constructor(props) {
        super(props);

        this.state = { loaded: false };
    }

    onLevelDescriptionClick = () => {};

    onLoadComplete = () => {
        store.dispatch(gameplayerSetLoadingComplete(true));
        this.setState({ loaded: true });
    };

    render() {
        const { loaded } = this.state;

        const { gameInfo } = this.props;
        const { viewDir } = gameInfo;

        return (
            <div className="full-height">
                <div id="player-canvas-wrapper" className="canvas-wrapper vertical-align">
                    <div className="canvas-overlay">
                        {loaded ? (
                            <>
                                <LevelPopup />
                                <div id="gameplayer-hud-overlay">
                                    <GameInfo />
                                    <PauseOverlay />
                                </div>

                                <MobileControls enabled={viewDir === ViewDirection.Side} />

                                <div className="lives-indicator-container pointer-events-none">
                                    <div className="lives-indicator" id="lives-indicator">
                                        <div>
                                            <div>
                                                <img src={`${settings.assetsPath}img/icons/heart.png`} alt="heart" />
                                                <span id="lives-indicator-text">{gameInfo.lives}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="splash-texts pointer-events-none">
                                    <img id="splash-text-1" className="splash-text" src={`${settings.assetsPath}img/splash/1.png`} alt="1" />
                                    <img id="splash-text-2" className="splash-text" src={`${settings.assetsPath}img/splash/2.png`} alt="2" />
                                    <img id="splash-text-3" className="splash-text" src={`${settings.assetsPath}img/splash/3.png`} alt="3" />
                                    <img id="splash-text-start" className="splash-text" src={`${settings.assetsPath}img/splash/start.png`} alt="START" />
                                    <img id="splash-text-finish" className="splash-text" src={`${settings.assetsPath}img/splash/finish.png`} alt="FINISH" />
                                    <img id="splash-text-level-over" className="splash-text" src={`${settings.assetsPath}img/splash/level_over.png`} alt="LEVEL OVER" />
                                    <img id="splash-text-game-over" className="splash-text" src={`${settings.assetsPath}img/splash/game_over.png`} alt="GAME OVER" />
                                </div>
                            </>
                        ) : (
                            <PlayerLoadScreen onComplete={this.onLoadComplete} />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    gameInfo: state.gameInfo
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GamePlayerUI);
